import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useMcpOverview(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ["platformAnalytics", "mcpOverview", fromDate, toDate],
    queryFn: () =>
      api.getMcpOverview({ from_date: fromDate, to_date: toDate }),
  });
}
